// import React, { useState, useRef, useEffect } from "react";
// import { createPortal } from "react-dom";
// import { saveComment } from "../context/CommonContex";

// const HoverPO = ({
//   comments,
//   position = "top",
//   children,
//   onDeleteComment,
//   onResolveThread,
//   onAddComment,
//   orderLineId
// }) => {
//   const [visible, setVisible] = useState(false);
//   const [newComment, setNewComment] = useState("");
//   const [newCommentStatus, setNewCommentStatus] = useState("pending");
//   const [showAddForm, setShowAddForm] = useState(false);
//   //const [orderLineId,setOrderLineId] = useState(orderLineId);
//   const [mapComment,setMapComment] = useState(comments);

//   const wrapperRef = useRef(null);
//   const triggerRef = useRef(null);
//   const popupRef = useRef(null);
//   const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });

//   // Outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         wrapperRef.current &&
//         !wrapperRef.current.contains(event.target) &&
//         popupRef.current &&
//         !popupRef.current.contains(event.target)
//       ) {
//         setVisible(false);
//         setShowAddForm(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Position popup
//   useEffect(() => {
//     if (visible && triggerRef.current) {
//       const rect = triggerRef.current.getBoundingClientRect();
//       setPopupPos({
//         top: rect.bottom + window.scrollY + 8,
//         left: rect.left + window.scrollX - 260,
//       });
//     }
//   }, [visible]);

//   const handleDeleteComment = (commentId) => {
//     if (
//       onDeleteComment &&
//       window.confirm("Are you sure you want to delete this comment?")
//     ) {
//       onDeleteComment(commentId);
//     }
//   };

//   const handleResolveThread = () => {
//     if (
//       onResolveThread &&
//       window.confirm("Are you sure you want to resolve this thread?")
//     ) {
//       onResolveThread();
//       setVisible(false);
//     }
//   };

//   const handleAddComment = () => {
//     if (newComment.trim() && onAddComment) {
//       onAddComment(newComment, newCommentStatus);
//       setNewComment("");
//       setNewCommentStatus("pending");
//       setShowAddForm(false);
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "resolved":
//         return "#28a745";
//       case "pending":
//         return "#ffc107";
//       case "urgent":
//         return "#dc3545";
//       default:
//         return "#6c757d";
//     }
//   };

//   const [formData, setFormData] = useState({
//           comment: "",
//           flowName: "Order",
//           status: "",
//           orderLineId: ""
//   });
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };
//   const handleSubmit = async (e) => {
//      e.preventDefault();
//      debugger
//       try {
//            formData.flowName = "Order";
//            formData.orderLineId = orderLineId;
//            const comment = await saveComment(formData);
//            setFormData({
//                   comment: "",
//                   flowName: "Order",
//                   status: "",
//                   orderLineId: ""
//           })
//            setMapComment(prev => [comment,...prev]);
//            setShowAddForm(false);
//           } catch (error) {
//               console.error("Error submitting form:", error);
//           }
//   };

//   return (
//     <div ref={wrapperRef} className="tooltip-wrapper">
//       {React.cloneElement(children, {
//         ref: triggerRef,
//         onClick: () => setVisible((v) => !v),
//         style: { ...children.props.style, position: "relative" },
//       })}

//       {/* Badge */}
//       {mapComment.length > 0 && (
//         <div
//           className="comment-badge"
//           style={{
//             backgroundColor: (() => {
//               const unresolvedCount = mapComment.filter((c) => !c.resolved).length;
//               const urgentCount = mapComment.filter(
//                 (c) => c.status === "urgent" && !c.resolved
//               ).length;
//               if (urgentCount > 0) return "#dc3545";
//               if (unresolvedCount > 0) return "#ffc107";
//               return "#28a745";
//             })(),
//           }}
//         >
//           {mapComment.filter((c) => !c.resolved).length || mapComment.length}
//         </div>
//       )}

//       {visible &&
//         createPortal(
//           <div
//             className={`tooltip-box tooltip-${position}`}
//             style={{ top: popupPos.top, left: popupPos.left }}
//             ref={popupRef}
//           >
//             {/* Header */}
//             <div className="tooltip-header">
//               <h6>Comments ({mapComment.length})</h6>
//               <div className="actions">
//                 <button
//                   className="btn btn-primary"
//                   onClick={() => setShowAddForm(!showAddForm)}
//                 >
//                   +
//                   Add
//                 </button>
//                 {mapComment.length > 0 && (
//                   <button className="btn btn-success" onClick={handleResolveThread}>
//                     ✓ Resolve
//                   </button>
//                 )}
//               </div>
//             </div>

//             {/* Add Comment */}
//             {showAddForm && (
//               <div className="add-comment">
//                 <textarea
//                   value={formData?.comment ?? ""}   // ✅ safer
//                   name="comment"
//                   onChange={(e)=> handleChange(e)}
//                   placeholder="Add a new comment..."
//                 />

//                 <div className="form-actions">
//                   {/* <select
//                     value={newCommentStatus}
//                     onChange={(e) => setNewCommentStatus(e.target.value)}
//                   >
//                     <option value="pending">Pending</option>
//                     <option value="urgent">Urgent</option>
//                     <option value="resolved">Resolved</option>
//                   </select> */}
//                   <button
//                     className="btn btn-primary"
//                     disabled={!formData?.comment?.trim()}
//                     onClick={handleSubmit}
//                   >
//                     Save
//                   </button>

//                   <button
//                     className="btn btn-secondary"
//                     onClick={() => {
//                       setShowAddForm(false);
//                       setNewComment("");
//                       setNewCommentStatus("pending");
//                     }}
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </div>
//             )}

//             {/* Comment List */}
//             {mapComment.length === 0 ? (
//               <div className="no-comments">
//                 <p>No comments yet.</p>
//                 <p>Click "Add" to start a conversation</p>
//               </div>
//             ) : (
//               <div className="comments-list">
//                 {mapComment.map((comment, index) => (
//                   <div
//                     key={comment.id || index}
//                     className={`comment-card ${comment.resolved ? "resolved" : ""}`}
//                   >
//                     <div className="comment-header">
//                       <div className="comment-user">
//                         <div className="user-avatar">
//                           {(comment.lastEditedBy || "U").charAt(0).toUpperCase()}
//                         </div>
//                         <div>
//                           <strong
//                             className={`user-name ${comment.resolved ? "resolved" : ""}`}
//                           >
//                             {comment.lastEditedBy || "Unknown User"}
//                           </strong>
//                           <div className="comment-meta">
//                             <span>
//                               {comment.dateStr} {comment.timeStr}
//                             </span>
//                             {comment.status && (
//                               <span
//                                 className="comment-status"
//                                 style={{ backgroundColor: getStatusColor(comment.status) }}
//                               >
//                                 {comment.status}
//                               </span>
//                             )}
//                             {comment.resolved && (
//                               <span
//                                 className="comment-status"
//                                 style={{ backgroundColor: "#28a745" }}
//                               >
//                                 Resolved
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       </div>

//                       <div>
//                         {onDeleteComment && (
//                           <button
//                             className="btn-icon"
//                             title="Delete comment"
//                             onClick={() =>
//                               handleDeleteComment(comment.id || index)
//                             }
//                           >
//                             🗑
//                           </button>
//                         )}
//                         {!comment.resolved && onResolveThread && (
//                           <button
//                             className="btn-icon"
//                             title="Mark as resolved"
//                             onClick={() => onResolveThread(comment.id || index)}
//                           >
//                             ✓
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                     <div className={`comment-body ${comment.resolved ? "resolved" : ""}`}>
//                       {comment.comment}
//                     </div>
//                     {comment.replyTo && (
//                       <div className="reply-indicator">
//                         ↳ Reply to {comment.replyTo}
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             )}

//             {/* Footer */}
//             {mapComment.length > 0 && (
//               <div className="tooltip-footer">
//                 {mapComment.filter((c) => c.resolved).length} of {mapComment.length} comments resolved
//               </div>
//             )}
//           </div>,
//           document.body
//         )}
//     </div>
//   );
// };

// export default HoverPO;
import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { deleteComment, deletePOComment, deleteQuoteComment, fetchQuoteById, saveComment, savePOComment, saveQuoteComment, getUsers } from "../context/CommonContex";
import InitialAvatar from './InitialAvatar';
import EmojiPickerButton from './Common/EmojiPickerButton';
import './Common/PresenceBar.css';
import { notifyOrderHistoryChanged } from './orderHistory/useOrderHistoryUnread';
import { formatThreadTitle, getCommentThreadKey, useCommentDock } from '../context/CommentDockContext';
import { extractCommentText, getCommentAuthor, getCommentId, isQuoteLikeRecord, isTempCommentId, normalizeComment, pickSavedComment } from '../utils/commentText';
import MentionSuggestions from './comments/MentionSuggestions';

// helper to escape regex special chars
const escapeRegex = (s) => {
  if (!s) return '';
  return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
};

const HoverPO = ({
  comments,
  position = "top",
  children,
  onDeleteComment,
  onResolveThread,
  onAddComment,
  onCommentsChange,
  orderLineId,
  quoteId,
  poLineId,
  threadKey: threadKeyProp,
  orderNumber,
  customerName,
  customerId,
  sourcePage = "orders",
  lineInfo,
  threadTitle,
  variant = "popup",
  /** Live presence: told whenever this notes popup opens or closes, so the grid
   *  can show "X is in the notes" on the row without it being expanded. */
  onVisibleChange,
  /** The trigger draws its own count badge (Orders INFO column comments icon). */
  hideBadge = false,
  /** Docked only: how many of the newest comments to mark as "New" (unread on open). */
  highlightCount = 0,
}) => {
  const [visible, setVisible] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [newCommentStatus, setNewCommentStatus] = useState("pending");
  const [showAddForm, setShowAddForm] = useState(false);
  const [mapComment, setMapComment] = useState((comments || []).map(c => normalizeComment(c)));
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [popupPos, setPopupPos] = useState({ top: -9999, left: -9999 });
  const [isPositioned, setIsPositioned] = useState(false);
  const [formData, setFormData] = useState({
    comment: "",
    flowName: "Order",
    status: "",
    orderLineId: ""
  });
  const [mentions, setMentions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const wrapperRef = useRef(null);
  const triggerRef = useRef(null);
  const popupRef = useRef(null);
  const commentRef = useRef(null);
  const suggestionTimeoutRef = useRef(null);
  // Track IDs deleted during this session so useEffect never restores them from a stale parent prop
  const deletedIdsRef = useRef(new Set());
  const sendingRef = useRef(false);
  const [sending, setSending] = useState(false);
  const isDocked = variant === "docked";
  const dock = useCommentDock();
  const dockRef = useRef(dock);
  dockRef.current = dock;
  const threadKey = threadKeyProp || getCommentThreadKey({ orderLineId, quoteId, poLineId });

  // Tell the parent when the popup opens/closes so it can claim or release the
  // presence cell for these notes. Kept in a ref so a new inline callback on
  // every parent render does not re-announce focus.
  const visibleChangeRef = useRef(onVisibleChange);
  visibleChangeRef.current = onVisibleChange;
  const dockThreadOpen = !isDocked && !!threadKey && !!dock?.isThreadOpen?.(threadKey);
  useEffect(() => {
    if (isDocked) return;
    if (dock?.isThreadOpen?.(threadKey) && !visible) return;
    visibleChangeRef.current?.(visible);
  }, [visible, isDocked]);
  // The dock window can close or minimize without this row's popup state changing.
  // Tell the grid either way, so the live face leaves when the chat is no longer open.
  useEffect(() => {
    if (isDocked || !threadKey) return undefined;
    visibleChangeRef.current?.(dockThreadOpen);
    return undefined;
  }, [dockThreadOpen, isDocked, threadKey]);
  // A row that scrolls out of the virtualised grid unmounts with the popup still
  // open - release the cell rather than leaving a ghost avatar on it.
  // If this thread is still open in the persistent dock, keep the presence lock.
  useEffect(() => () => {
    if (isDocked) return;
    if (dock?.isThreadOpen?.(threadKey)) return;
    visibleChangeRef.current?.(false);
  }, []);

  // Keep the notes cell and the floating chat on the same list.
  // Parent comments win; only keep in-progress optimistic (tmp-) rows locally.
  useEffect(() => {
    setMapComment(prev => {
      const parentComments = (comments || [])
        .filter(c => c && !isQuoteLikeRecord(c) && !deletedIdsRef.current.has(String(getCommentId(c))))
        .map(c => {
          const normalized = normalizeComment(c);
          const previous = prev.find((item) => String(getCommentId(item)) === String(getCommentId(normalized)));
          if (previous?.lastEditedBy && !normalized.lastEditedBy) {
            normalized.lastEditedBy = previous.lastEditedBy;
          }
          return normalized;
        });
      const parentIds = new Set(parentComments.map(c => String(getCommentId(c))));
      const localOnly = prev.filter((c) => {
        const id = String(getCommentId(c) || '');
        return id.startsWith('tmp-')
          && !deletedIdsRef.current.has(id)
          && !parentIds.has(id);
      });
      return [...localOnly, ...parentComments];
    });
  }, [comments]);

  useEffect(() => {
    if (isDocked) setShowAddForm(true);
  }, [isDocked]);

  useEffect(() => {
    const currentDock = dockRef.current;
    if (!currentDock || !threadKey || isDocked) return;
    currentDock.registerHandlers(threadKey, {
      onAddComment,
      onDeleteComment,
      onResolveThread,
      onVisibleChange: (isVisible) => visibleChangeRef.current?.(isVisible),
    });
    if (currentDock.isThreadOpen?.(threadKey)) {
      visibleChangeRef.current?.(true);
    }
  }, [threadKey, isDocked, onAddComment, onDeleteComment, onResolveThread]);

  // Also runs when this record's chat appears in the dock (for example opened from a
  // notification), so the window gets the row's comments without another fetch.
  const threadInDock = !isDocked && !!threadKey && !!dock?.threads?.some((t) => t.key === threadKey);
  useEffect(() => {
    const currentDock = dockRef.current;
    if (!currentDock || !threadKey || isDocked) return;
    if (!currentDock.isThreadOpen?.(threadKey)) return;
    currentDock.updateThreadComments?.(
      threadKey,
      Array.isArray(mapComment) ? mapComment.map(normalizeComment) : []
    );
  }, [threadKey, isDocked, mapComment, threadInDock]);

  const openPersistentThread = () => {
    if (!dock?.openThread || !threadKey) return false;
    dock.openThread({
      key: threadKey,
      expand: true,
      orderLineId,
      quoteId,
      poLineId,
      sourcePage,
      title: threadTitle || formatThreadTitle({ orderNumber, quoteId, poLineId, orderLineId }),
      subtitle: customerName || '',
      lineInfo: lineInfo || '',
      orderNumber,
      customerId,
      comments: mapComment,
      onAddComment,
      onDeleteComment,
      onResolveThread,
      onVisibleChange: (isVisible) => visibleChangeRef.current?.(isVisible),
    });
    visibleChangeRef.current?.(true);
    return true;
  };

  // Outside click
  useEffect(() => {
    if (isDocked) return;
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setVisible(false);
        setShowAddForm(false);
        // Clear mentions and suggestions when closing
        setSuggestions([]);
        setShowSuggestions(false);
        setMentions([]);
        setFormData({ comment: '', flowName: 'Order', status: '', orderLineId: '' });
        if (suggestionTimeoutRef.current) {
          clearTimeout(suggestionTimeoutRef.current);
          suggestionTimeoutRef.current = null;
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close popup when scrolling occurs (either window or any scrollable ancestor)
  useEffect(() => {
    if (!visible || isDocked) return;

    const handleScrollClose = () => {
      setVisible(false);
      setShowAddForm(false);
      // Clear mentions and suggestions when scrolling closes popup
      setSuggestions([]);
      setShowSuggestions(false);
      setMentions([]);
      setFormData({ comment: '', flowName: 'Order', status: '', orderLineId: '' });
      if (suggestionTimeoutRef.current) {
        clearTimeout(suggestionTimeoutRef.current);
        suggestionTimeoutRef.current = null;
      }
    };

    // always listen to window scroll
    window.addEventListener('scroll', handleScrollClose, { passive: true });

    // also attach to any scrollable ancestors so internal scrolls close it too
    const addedElements = [];
    try {
      let el = wrapperRef.current ? wrapperRef.current.parentElement : null;
      while (el) {
        const style = window.getComputedStyle(el);
        const overflow = (style.overflow + style.overflowY + style.overflowX).toLowerCase();
        if (overflow.includes('auto') || overflow.includes('scroll')) {
          el.addEventListener('scroll', handleScrollClose, { passive: true });
          addedElements.push(el);
        }
        el = el.parentElement;
      }
    } catch (e) {
      // ignore
    }

    return () => {
      window.removeEventListener('scroll', handleScrollClose);
      addedElements.forEach(a => a.removeEventListener('scroll', handleScrollClose));
    };
  }, [visible]);

  // cleanup suggestion timeout on unmount
  useEffect(() => {
    return () => {
      if (suggestionTimeoutRef.current) clearTimeout(suggestionTimeoutRef.current);
    };
  }, []);

  // Handle keyboard events - Escape key to close suggestions
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && showSuggestions) {
        setShowSuggestions(false);
        setSuggestions([]);
        if (suggestionTimeoutRef.current) {
          clearTimeout(suggestionTimeoutRef.current);
          suggestionTimeoutRef.current = null;
        }
      }
    };

    if (showSuggestions) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [showSuggestions]);

  // Handle clicks outside suggestion dropdown
  useEffect(() => {
    const handleClickOutsideSuggestions = (event) => {
      if (showSuggestions && commentRef.current && !commentRef.current.contains(event.target)) {
        const suggestionDropdown = document.querySelector('.mention-suggestions-dropdown');
        if (suggestionDropdown && !suggestionDropdown.contains(event.target)) {
          setShowSuggestions(false);
          setSuggestions([]);
        }
      }
    };

    if (showSuggestions) {
      document.addEventListener('mousedown', handleClickOutsideSuggestions);
      return () => document.removeEventListener('mousedown', handleClickOutsideSuggestions);
    }
  }, [showSuggestions]);

  // Position popup - precise positioning
  useEffect(() => {
    if (visible && triggerRef.current) {
      setIsPositioned(false); // Reset positioning flag
      
      const calculatePosition = () => {
        try {
          const buttonRect = triggerRef.current.getBoundingClientRect();
          const popupWidth = 350;
          const popupHeight = 300;
          
          // Get the exact button position
          const buttonLeft = buttonRect.left;
          const buttonTop = buttonRect.top;
          const buttonBottom = buttonRect.bottom;
          const buttonRight = buttonRect.right;
          
          // Calculate initial position - directly below the button
          let left = buttonLeft;
          let top = buttonBottom + 5; // Small gap below button
          
          // Adjust horizontal position to prevent overflow
          if (left + popupWidth > window.innerWidth) {
            left = buttonRight - popupWidth;
          }
          
          // Adjust vertical position if it would go off screen
          if (top + popupHeight > window.innerHeight) {
            top = buttonTop - popupHeight - 5; // Above the button
          }
          
          // Ensure minimum margins
          if (left < 10) left = 10;
          if (top < 10) top = 10;
          
          setPopupPos({ 
            top: Math.round(top), 
            left: Math.round(left) 
          });
          
          // Mark as positioned after calculation
          setIsPositioned(true);
        } catch (error) {
          console.error('Position calculation error:', error);
          setIsPositioned(true); // Still show even if error
        }
      };

      // Calculate position with a small delay to ensure DOM is ready
      const timeoutId = setTimeout(calculatePosition, 10);
      
      return () => {
        clearTimeout(timeoutId);
        setIsPositioned(false);
      };
    } else {
      setIsPositioned(false);
    }
  }, [visible]);

  const handleDeleteComment = (commentId) => {
    if (
      onDeleteComment &&
      window.confirm("Are you sure you want to delete this comment?")
    ) {
      onDeleteComment(commentId);
    }
  };

  const handleResolveThread = () => {
    if (
      onResolveThread &&
      window.confirm("Are you sure you want to resolve this thread?")
    ) {
      onResolveThread();
      setVisible(false);
    }
  };

  const handleAddComment = () => {
    if (newComment.trim() && onAddComment) {
      onAddComment(newComment, newCommentStatus);
      setNewComment("");
      setNewCommentStatus("pending");
      setShowAddForm(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved":
        return "#28a745";
      case "pending":
        return "#ffc107";
      case "urgent":
        return "#dc3545";
      default:
        return "#6c757d";
    }
  };

  const handleChange = (e) => {
    const { name, value, selectionStart } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // detect mention token before caret
    const pos = selectionStart || value.length;
    const lastAt = value.lastIndexOf('@', pos - 1);
    
    // Check if there's a valid @ mention context
    let shouldShowSuggestions = false;
    
    if (lastAt >= 0) {
      // ensure @ is start or preceded by whitespace
      const before = value[lastAt - 1];
      if (!before || /\s/.test(before)) {
        const token = value.slice(lastAt + 1, pos);
        // Check if token exists and doesn't contain whitespace (which would end the mention)
        if (token !== undefined && !token.includes(' ') && !token.includes('\n')) {
          if (token.length >= 2) {
            // debounce search
            if (suggestionTimeoutRef.current) clearTimeout(suggestionTimeoutRef.current);
            suggestionTimeoutRef.current = setTimeout(async () => {
              try {
                const users = await getUsers(token);
                // expect users as array of { username, displayName, email }
                setSuggestions(users || []);
                setShowSuggestions(Array.isArray(users) && users.length > 0);
              } catch (err) {
                console.error('Error fetching user suggestions', err);
                setSuggestions([]);
                setShowSuggestions(false);
              }
            }, 250);
            shouldShowSuggestions = true;
          } else if (token.length < 2 && token.length > 0) {
            // @ is present with 0-1 character, keep dropdown closed but don't clear suggestions yet
            shouldShowSuggestions = false;
          }
        }
      }
    }

    // Clear suggestions if @ is not found or invalid context
    if (!shouldShowSuggestions) {
      setShowSuggestions(false);
      setSuggestions([]);
      if (suggestionTimeoutRef.current) {
        clearTimeout(suggestionTimeoutRef.current);
        suggestionTimeoutRef.current = null;
      }
    }

    // Keep only mentions that still appear in the text. This prevents partial tokens
    // from being kept (and from being sent) if the user erases them.
    try {
      const text = value || '';
      setMentions(prev => {
        if (!prev || prev.length === 0) return prev || [];
        return prev.filter(m => {
          if (!m || !m.username) return false;
          const re = new RegExp(`@${escapeRegex(m.username)}(\\s|$)`, 'g');
          return re.test(text);
        });
      });
    } catch (err) {
      // ignore parse errors
    }
  };
  const handleSelectSuggestion = (user) => {
    // insert @username into comment replacing current token
    const textarea = commentRef.current;
    if (!textarea) return;
    const { selectionStart } = textarea;
    const val = formData.comment || '';
    const lastAt = val.lastIndexOf('@', selectionStart - 1);
    if (lastAt < 0) return;
    const before = val.slice(0, lastAt + 1);
    const after = val.slice(selectionStart);
    const mentionText = user.username || user.email || user.name;
    const insert = `${mentionText} `;
    const newComment = before + insert + after;
    setFormData(prev => ({ ...prev, comment: newComment }));
    // Add the selected user to mentions with email if available. Use email for backend.
    const userEmail = user.email || user.username || '';
    setMentions(prev => {
      const exists = (prev || []).some(m => (m.email && userEmail && m.email === userEmail) || m.username === mentionText);
      if (exists) return prev;
      return [...(prev || []), { username: mentionText, email: userEmail, displayName: user.displayName || mentionText }];
    });
    setShowSuggestions(false);
    setSuggestions([]);
    // move caret after inserted text
    setTimeout(() => {
      const pos = (before + insert).length;
      textarea.focus();
      textarea.setSelectionRange(pos, pos);
    }, 0);
  };

  const insertEmojiAtCursor = (emoji) => {
    const textarea = commentRef.current;
    const val = formData.comment ?? '';
    const start = textarea ? textarea.selectionStart : val.length;
    const end = textarea ? textarea.selectionEnd : val.length;
    const before = val.slice(0, start);
    const after = val.slice(end);
    const newComment = before + emoji + after;
    setFormData(prev => ({ ...prev, comment: newComment }));
    if (textarea) {
      setTimeout(() => {
        const pos = (before + emoji).length;
        textarea.focus();
        textarea.setSelectionRange(pos, pos);
      }, 0);
    }
  };

  // Saving a note re-renders the wide grid. Keep the page and the table
  // scroll where the user left them so a bottom scrollbar does not jump in.
  const pageScrollRef = useRef(null);
  const capturePageScroll = () => {
    const saved = [];
    const add = (el) => {
      if (!el || saved.some((item) => item.el === el)) return;
      saved.push({ el, left: el.scrollLeft, top: el.scrollTop });
    };
    if (typeof document !== 'undefined') {
      add(document.scrollingElement);
      document.querySelectorAll(
        '.orders-tables-region, .order-validation-table-scroll, .po-order-validation-table-scroll'
      ).forEach(add);
    }
    pageScrollRef.current = saved;
  };
  const restorePageScroll = () => {
    const saved = pageScrollRef.current;
    if (!saved) return;
    saved.forEach(({ el, left, top }) => {
      if (!el || !el.isConnected) return;
      if (el.scrollLeft !== left) el.scrollLeft = left;
      if (el.scrollTop !== top) el.scrollTop = top;
    });
  };
  useLayoutEffect(() => {
    restorePageScroll();
  });

  const handleSubmit = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (sendingRef.current || !formData?.comment?.trim()) return;
    capturePageScroll();
    sendingRef.current = true;
    setSending(true);
    try {
      const payload = { ...formData };
      payload.flowName = poLineId ? 'Purchase Order' : (quoteId ? 'Quote' : 'Order');
      payload.orderLineId = orderLineId;
      payload.quoteId = quoteId;
      payload.poLineId = poLineId;
      payload.sourcePage = sourcePage;
      payload.lastEditedBy = localStorage.getItem('userEmail')
        || localStorage.getItem('email')
        || localStorage.getItem('userName')
        || 'You';

      // Send only selected mentions' emails to backend
      payload.mentions = Array.from(new Set((mentions || []).map(m => m.email).filter(Boolean)));

      console.log('=== ADDING COMMENT DEBUG ===');
      console.log('Payload being sent:', payload);

      // Optimistic update: show the comment immediately in UI while saving.
      const tempId = `tmp-${Date.now()}`;
      const now = new Date();
      const localUser = localStorage.getItem('userEmail') || 'You';
      const optimistic = {
        id: tempId,
        comment: extractCommentText(payload.comment) || (typeof payload.comment === 'string' ? payload.comment : ''),
        lastEditedBy: localUser,
        dateStr: now.toLocaleDateString(),
        timeStr: now.toLocaleTimeString(),
        status: payload.status || '',
        resolved: false,
      };

      console.log('Optimistic comment created with temp ID:', tempId);
      setMapComment(prev => {
        const next = [optimistic, ...prev];
        if (typeof onCommentsChange === 'function') onCommentsChange(next);
        return next;
      });

      let serverComment = null;
      try {
        if (poLineId) {
          serverComment = await savePOComment(payload);
        } else if (orderLineId) {
          console.log('Saving comment to order line:', orderLineId);
          serverComment = await saveComment(payload);
        } else if (quoteId) {
          console.log('Saving comment to quote:', quoteId);
          serverComment = await saveQuoteComment(payload);
          if (isTempCommentId(getCommentId(pickSavedComment(serverComment, optimistic)))) {
            try {
              const quote = await fetchQuoteById(quoteId);
              if (quote) serverComment = quote;
            } catch (fetchErr) {
              console.warn('Could not reload quote after saving comment:', fetchErr);
            }
          }
        }
        console.log('Server response:', serverComment);
      } catch (err) {
        console.error('Error saving comment to server:', err);
        // remove optimistic comment on failure
        setMapComment(prev => prev.filter(c => c.id !== tempId));
        throw err;
      }

      // replace optimistic comment with the actual saved comment, not a quote wrapper
      if (serverComment) {
        const normalizedServerComment = pickSavedComment(serverComment, optimistic);

        console.log('Normalized server comment:', normalizedServerComment);

        if (normalizedServerComment && (normalizedServerComment.id || normalizedServerComment.comment)) {
          console.log('Replacing temp comment (ID: ' + tempId + ') with server comment (ID: ' + normalizedServerComment.id + ')');
          setMapComment(prev => {
            const replaced = prev.map(c => (c.id === tempId ? normalizedServerComment : c));
            if (typeof onCommentsChange === 'function') onCommentsChange(replaced);
            return replaced;
          });

          try {
            if (typeof onAddComment === 'function') {
              console.log('Calling parent onAddComment');
              onAddComment(normalizedServerComment, payload.status || 'pending');
            }
          } catch (err) {
            // ignore parent update errors
          }
        } else {
          console.warn('Server comment missing ID:', normalizedServerComment);
          try {
            if (typeof onAddComment === 'function') {
              onAddComment(optimistic, payload.status || 'pending');
            }
          } catch (err) {
            /* ignore */
          }
        }
      } else {
        console.warn('No server response received, keeping optimistic comment');
        try {
          if (typeof onAddComment === 'function') {
            onAddComment(optimistic, payload.status || 'pending');
          }
        } catch (err) {
          /* ignore */
        }
      }

      // Save succeeded. Empty the box now, before Teams or anything else.
      setFormData({ comment: '', flowName: 'Order', status: '', orderLineId: '' });
      setMentions([]);
      setSuggestions([]);
      if (!isDocked) setShowAddForm(false);

      // Send Teams notification
      try {
        const { sendTeamsNotification } = await import('../context/CommonContex');
        await sendTeamsNotification({
          comment: payload.comment,
          addedBy: localUser,
          orderNumber: orderNumber || 'N/A',
          orderLineId: orderLineId,
          customerName: customerName || null,
          customerId: customerId || null,
          mentions: payload.mentions || [],
        });
      } catch (err) {
        console.warn('Teams notification failed, but comment was saved:', err);
        // Don't fail the submission if Teams notification fails
      }

      if (orderLineId && orderNumber) {
        notifyOrderHistoryChanged(orderNumber);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      sendingRef.current = false;
      setSending(false);
      restorePageScroll();
      requestAnimationFrame(() => {
        restorePageScroll();
        requestAnimationFrame(() => {
          restorePageScroll();
          pageScrollRef.current = null;
        });
      });
    }
  };

  const removeMention = (mention) => {
    // mention can be email or username; prefer username removal from text
    const username = mention.username || (mention.email ? (mention.email.split('@')[0]) : mention);
    setMentions(prev => (prev || []).filter(m => {
      if (mention.email && m.email) return m.email !== mention.email;
      return m.username !== username;
    }));

    // remove occurrences of @username from the comment text
    setFormData(prev => {
      const text = prev.comment || '';
      const re = new RegExp(`@${escapeRegex(username)}(\\s)?`, 'g');
      const updated = text.replace(re, '');
      return { ...prev, comment: updated.trim().replace(/\s{2,}/g, ' ') };
    });
  }
  const handleDelete = (commentId) => {
    // Show inline confirmation instead of window.confirm (blocked inside Bootstrap modals)
    setConfirmDeleteId(commentId);
  };

  const confirmDelete = async (commentId) => {
    setConfirmDeleteId(null);

    // Optimistic update — synchronous so React flushes immediately
    const target = mapComment.find((c) => {
      const id = getCommentId(c);
      return String(id) === String(commentId) || String(c?.id) === String(commentId) || String(c?.commentId) === String(commentId);
    });
    const backendId = getCommentId(target) || (!isTempCommentId(commentId) ? commentId : null);

    if (backendId) deletedIdsRef.current.add(String(backendId));
    if (commentId) deletedIdsRef.current.add(String(commentId));

    setMapComment(prev => {
      const next = prev.filter((c) => {
        const id = getCommentId(c);
        if (backendId != null && String(id) === String(backendId)) return false;
        if (commentId != null && (
          String(id) === String(commentId)
          || String(c?.id) === String(commentId)
          || String(c?.commentId) === String(commentId)
        )) return false;
        return true;
      });
      if (typeof onCommentsChange === 'function') onCommentsChange(next);
      return next;
    });

    // Notify parent synchronously so its state updates batch with the above
    if (typeof onDeleteComment === 'function') {
      try {
        onDeleteComment(backendId || commentId);
      } catch (err) {
        console.error('Parent update error:', err);
      }
    }

    try {
      if (isTempCommentId(backendId)) {
        return;
      }
      if (poLineId) {
        await deletePOComment(backendId, poLineId);
      } else if (orderLineId) {
        await deleteComment(backendId, orderLineId);
        if (orderNumber) notifyOrderHistoryChanged(orderNumber);
      } else if (quoteId) {
        await deleteQuoteComment(backendId, quoteId);
      } else {
        console.error('Neither orderLineId, quoteId, nor poLineId provided');
      }
    } catch (error) {
      console.error('Error deleting comment:', error);
    }
  };

  const handleComposerKeyDown = (e) => {
    if (!isDocked) return;
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (formData?.comment?.trim()) handleSubmit(e);
    }
  };

  if (isDocked) {
    return (
      <div className="comment-dock-thread-body">
        <div className="comment-dock-history">
          {mapComment.length === 0 ? (
            <div className="no-comments">
              <p>No comments yet.</p>
            </div>
          ) : (
            <div className="comments-list">
              {mapComment.map((comment, index) => (
                <div
                  key={comment.id || `comment-${index}`}
                  className={`comment-card ${comment.resolved ? "resolved" : ""}${index < highlightCount ? " is-new" : ""}`}
                >
                  <div className="comment-header">
                    <div className="comment-user">
                      <InitialAvatar name={getCommentAuthor(comment) || comment.lastEditedBy || 'U'} />
                      <div>
                        <strong className={`user-name ${comment.resolved ? "resolved" : ""}`}>
                          {(getCommentAuthor(comment) || comment.lastEditedBy || "Unknown User").split('@')[0]}
                        </strong>
                        <div className="comment-meta">
                          {index < highlightCount && <span className="comment-new-pill">New</span>}
                          {comment.lineLabel ? <span>{comment.lineLabel}</span> : null}
                          <span>{comment.dateStr} {comment.timeStr}</span>
                          {comment.status && comment.status.toString().toLowerCase() !== "pending" && (
                            <span className="comment-status" style={{ backgroundColor: getStatusColor(comment.status) }}>
                              {comment.status}
                            </span>
                          )}
                          {comment.resolved && (
                            <span className="comment-status" style={{ backgroundColor: "#28a745" }}>Resolved</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div>
                      {confirmDeleteId === getCommentId(comment) ? (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ fontSize: '0.7rem', color: '#555' }}>Delete?</span>
                          <button className="btn btn-danger btn-sm py-0 px-1" style={{ fontSize: '0.7rem' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); confirmDelete(getCommentId(comment)); }}>Yes</button>
                          <button className="btn btn-secondary btn-sm py-0 px-1" style={{ fontSize: '0.7rem' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmDeleteId(null); }}>No</button>
                        </span>
                      ) : (
                        <button className="btn-icon" title="Delete comment" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(getCommentId(comment)); }} style={{ cursor: 'pointer' }}>🗑</button>
                      )}
                      {!comment.resolved && onResolveThread && (
                        <button className="btn-icon" title="Mark as resolved" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onResolveThread(comment.id || index); }} style={{ cursor: 'pointer' }}>✓</button>
                      )}
                    </div>
                  </div>
                  <div className={`comment-body ${comment.resolved ? "resolved" : ""}`}>{extractCommentText(comment)}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="comment-dock-composer">
            <div className="comment-dock-composer-field">
              <textarea
                ref={commentRef}
                value={formData?.comment ?? ""}
                name="comment"
                onChange={(e) => handleChange(e)}
                onKeyDown={handleComposerKeyDown}
                placeholder="Write a comment... Type @ to mention someone"
                rows={2}
              />
              <span style={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
                <EmojiPickerButton onSelect={insertEmojiAtCursor} title="Add emoji" />
              </span>
              {showSuggestions && suggestions && suggestions.length > 0 && (
                <MentionSuggestions users={suggestions} onSelect={handleSelectSuggestion} />
              )}
            </div>
            {mentions && mentions.length > 0 && (
              <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {mentions.map((m, idx) => (
                  <div key={idx} style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 8px', background: '#eef2ff', borderRadius: 16, border: '1px solid #d0d7ff' }}>
                    <span style={{ marginRight: 8, fontSize: 12 }}>{m.displayName || (m.email ? m.email.split('@')[0] : m.username)}</span>
                    <button type="button" onClick={() => removeMention(m)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, lineHeight: 1 }} aria-label={`Remove ${m.displayName || m.username}`}>✕</button>
                  </div>
                ))}
              </div>
            )}
            <p className="comment-dock-hint">Enter to send · Shift+Enter for a new line</p>
            <div className="comment-dock-composer-actions">
              <button type="button" className="btn btn-primary" disabled={sending || !formData?.comment?.trim()} onMouseDown={(e) => e.preventDefault()} onClick={handleSubmit}>Send</button>
            </div>
          </div>
      </div>
    );
  }

  return (
    <div ref={wrapperRef} className="tooltip-wrapper">
      {React.cloneElement(children, {
        ref: triggerRef,
        onClick: (e) => {
          if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
          if (typeof children.props.onClick === 'function') children.props.onClick(e);
          if (openPersistentThread()) return;
          setVisible((v) => !v);
        },
        title: children.props.title || "Expand notes",
        style: { ...children.props.style, position: "relative" },
      })}

      {/* Badge */}
      {!hideBadge && mapComment.length > 0 && (
        <div
          className="comment-badge"
          style={{
            backgroundColor: (() => {
              const unresolvedCount = mapComment.filter((c) => !c.resolved).length;
              const urgentCount = mapComment.filter(
                (c) => c.status === "urgent" && !c.resolved
              ).length;
              if (urgentCount > 0) return "#dc3545";
              if (unresolvedCount > 0) return "#ffc107";
              return "#28a745";
            })(),
          }}
        >
          {mapComment.filter((c) => !c.resolved).length || mapComment.length}
        </div>
      )}

      {visible && isPositioned &&
        createPortal(
          <div
            className={`tooltip-box tooltip-${position}`}
            style={{ top: popupPos.top, left: popupPos.left }}
            ref={popupRef}
          >
            {/* Header */}
            <div className="tooltip-header">
              <h6>Comments ({mapComment.length})</h6>
              <div className="actions">
                <button
                  className="btn btn-primary"
                  title="Add a note"
                  onClick={() => setShowAddForm(!showAddForm)}
                >
                  +
                  Add
                </button>
                {mapComment.length > 0 && (
                  <button
                    className="btn btn-success"
                    onClick={handleResolveThread}
                  >
                    ✓ Resolve
                  </button>
                )}
              </div>
            </div>

            {/* Add Comment */}
            {showAddForm && (
              <div className="add-comment" style={{ position: 'relative' }}>
                <div style={{ position: 'relative', width: '100%' }}>
                  <textarea
                    ref={commentRef}
                    value={formData?.comment ?? ""}
                    name="comment"
                    onChange={(e)=> handleChange(e)}
                    placeholder="Add a new comment..."
                    rows={3}
                    style={{ width: '100%', resize: 'vertical', paddingRight: 36, fontSize: '1.5rem', lineHeight: 1.5 }}
                  />
                  <span style={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
                    <EmojiPickerButton onSelect={insertEmojiAtCursor} title="Add emoji" />
                  </span>
                  {showSuggestions && suggestions && suggestions.length > 0 && (
                    <MentionSuggestions users={suggestions} onSelect={handleSelectSuggestion} inline />
                  )}
                </div>

                {mentions && mentions.length > 0 && (
                  <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {mentions.map((m, idx) => (
                      <div key={idx} style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 8px', background: '#eef2ff', borderRadius: 16, border: '1px solid #d0d7ff' }}>
                        <span style={{ marginRight: 8, fontSize: 12 }}>{m.displayName || (m.email ? m.email.split('@')[0] : m.username)}</span>
                        <button type="button" onClick={() => removeMention(m)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, lineHeight: 1 }} aria-label={`Remove ${m.displayName || m.username}`}>
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div className="form-actions">
                  {/* <select
                    value={newCommentStatus}
                    onChange={(e) => setNewCommentStatus(e.target.value)}
                  >
                    <option value="pending">Pending</option>
                    <option value="urgent">Urgent</option>
                    <option value="resolved">Resolved</option>
                  </select> */}
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={sending || !formData?.comment?.trim()}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={handleSubmit}
                  >
                    Save
                  </button>

                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowAddForm(false);
                      setNewComment("");
                      setNewCommentStatus("pending");
                      setFormData({ comment: '', flowName: 'Order', status: '', orderLineId: '' });
                      setMentions([]);
                      setSuggestions([]);
                      setShowSuggestions(false);
                      if (suggestionTimeoutRef.current) {
                        clearTimeout(suggestionTimeoutRef.current);
                        suggestionTimeoutRef.current = null;
                      }
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {/* Comment List */}
            {mapComment.length === 0 ? (
              <div className="no-comments">
                <p>No comments yet.</p>
                <p>Click "Add" to start a conversation</p>
              </div>
            ) : (
              <div className="comments-list">
                {mapComment.map((comment, index) => {
                  // Debug: log comment structure
                  if (!comment.id && index < 3) {
                    console.warn('Comment without ID found:', comment);
                  }
                  return (
                  <div
                    key={comment.id || `comment-${index}`}
                    className={`comment-card ${comment.resolved ? "resolved" : ""}`}
                  >
                    <div className="comment-header">
                      <div className="comment-user">
                        <InitialAvatar name={getCommentAuthor(comment) || comment.lastEditedBy || 'U'} />
                        <div>
                          <strong className={`user-name ${comment.resolved ? "resolved" : ""}`}>
                            {(getCommentAuthor(comment) || comment.lastEditedBy || "Unknown User").split('@')[0]}
                          </strong>

                          <div className="comment-meta">
                            {comment.lineLabel ? <span>{comment.lineLabel}</span> : null}
                            <span>
                              {comment.dateStr} {comment.timeStr}
                            </span>
                            {comment.status && comment.status.toString().toLowerCase() !== "pending" && (
                              <span
                                className="comment-status"
                                style={{ backgroundColor: getStatusColor(comment.status) }}
                              >
                                {comment.status}
                              </span>
                            )}
                            {comment.resolved && (
                              <span
                                className="comment-status"
                                style={{ backgroundColor: "#28a745" }}
                              >
                                Resolved
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div>
                        {confirmDeleteId === getCommentId(comment) ? (
                          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span style={{ fontSize: '0.7rem', color: '#555' }}>Delete?</span>
                            <button
                              className="btn btn-danger btn-sm py-0 px-1"
                              style={{ fontSize: '0.7rem' }}
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); confirmDelete(getCommentId(comment)); }}
                            >Yes</button>
                            <button
                              className="btn btn-secondary btn-sm py-0 px-1"
                              style={{ fontSize: '0.7rem' }}
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmDeleteId(null); }}
                            >No</button>
                          </span>
                        ) : (
                          <button
                            className="btn-icon"
                            title="Delete comment"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDelete(getCommentId(comment));
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            🗑
                          </button>
                        )}
                        {!comment.resolved && onResolveThread && (
                          <button
                            className="btn-icon"
                            title="Mark as resolved"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              onResolveThread(comment.id || index)
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            ✓
                          </button>
                        )}
                      </div>
                    </div>
                    <div className={`comment-body ${comment.resolved ? "resolved" : ""}`}>
                      {extractCommentText(comment)}
                    </div>
                    {comment.replyTo && (
                      <div className="reply-indicator">
                        ↳ Reply to {comment.replyTo}
                      </div>
                    )}
                  </div>
                  );
                })}
              </div>
            )}

            {/* Footer */}
            {mapComment.length > 0 && (
              <div className="tooltip-footer">
                {mapComment.filter((c) => c.resolved).length} of {mapComment.length} comments resolved
              </div>
            )}
          </div>,
          document.body
        )}
    </div>
  );
};

export default HoverPO;
